export default "__VITE_ASSET__ez292cHd__"